import createRoutine from '@/utils/createRoutine'

export const creditScoreDetailsRoutine = createRoutine('creditScoreDetailsRoutine')

export const creditScoreGetters = {
  CREDIT_SCORE_DETAILS: 'CREDIT_SCORE_DETAILS'
}

export const CREDIT_SCORE_DETAILS_CLEANUP = 'CREDIT_SCORE_DETAILS_CLEANUP'
